import { render, staticRenderFns } from "./StatisticsPanel.vue?vue&type=template&id=7923912e&scoped=true&"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPanel.vue?vue&type=style&index=0&id=7923912e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7923912e",
  null
  
)

export default component.exports